//import deburr from "lodash/deburr";

import { useRef, useEffect, useState } from "react";

//Unform e componentes
import { useField } from "@unform/core";
import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate,
  FloatingPortal,
  useDismiss,
  useInteractions,
} from "@floating-ui/react";
import Select, { components } from "react-select";
import { styleSelect } from "../style/styleSelect";
import TooltipItem from "../TooltipItem";

//Common
import { fn_isValidNumber } from "@/common/utils/util";
import { SHOW_DESC_OBRIGATORIO_FIELDS } from "@/common/constantes";

//Util
import { ICONES_ACESSO } from "@/frontend/utils/icones";
import { fn_agruparOpcoesSelect } from "@/frontend/utils/form";

export default function USelect({
  name,
  label,
  maxMenuHeight,
  isSearchable,
  ariaLabel,
  optionsNoClearable,
  optionsDisabled,
  placeholder,
  textHelp,
  styles,
  showCheckbox = false,
  showTooltip = false,
  searchInTexto = false,
  destacarInativo = false,
  showGrupoCheck = false, //Agrupa as opções com o título do grupo (não selecionável) antes das opções de cada grupo
  getGrupoOpcao, //Com showGrupoCheck: função que retorna o nome do grupo da opção (sem grupo: null)
  footer,
  ...rest
}) {
  const selectRef = useRef(null);
  const customComponents = {};

  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: "value",

      getValue: (ref) => {
        if (rest.isMulti) {
          return ref.state.selectValue.map((option) => option.value);
        } else {
          return ref.state.selectValue[0]?.value;
        }
      },
      setValue: (ref, value) => {
        ref.setValue(value);
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  //Não permite excluir o item
  if (optionsNoClearable?.length > 0) {
    const isOptionNoClearable = (value) =>
      optionsNoClearable?.some((item) =>
        fn_isValidNumber(item) && fn_isValidNumber(value)
          ? Number(item) == Number(value)
          : item == value,
      );

    customComponents.MultiValueRemove = (props) => {
      const { data } = props;

      // if (
      //   optionsNoClearable.includes(
      //     fn_isValidNumber(data.value) ? Number(data.value) : data.value,
      //   )
      // ) {
      //   return null;
      // }
      if (isOptionNoClearable(data.value)) {
        return null;
      }

      return <components.MultiValueRemove {...props} />;
    };
  }

  //Limita a qtde de itens apresentados no select e apresenta + x itens
  customComponents.MultiValue = (props) => {
    const { index, getValue, selectProps } = props;
    const maxToShow = 3; // Qtde de itens que são apresentados e os demais ficam no + x itens
    const allSelected = getValue();

    const [open, setOpen] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
      open,
      onOpenChange: setOpen,
      placement: "bottom-start",
      middleware: [offset(6), flip(), shift({ padding: 8 })],
      whileElementsMounted: autoUpdate,
    });

    const dismiss = useDismiss(context);
    //const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);
    const { getFloatingProps } = useInteractions([dismiss]);

    if (index < maxToShow) {
      return <components.MultiValue {...props} />;
    }
    //Apresntação se ultrapassar o máximo de itens definido
    else if (index === maxToShow) {
      const hiddenItems = allSelected.slice(maxToShow);

      return (
        <>
          <div
            ref={refs.setReference}
            style={{ padding: "0 6px", cursor: "pointer" }}
            className="text-primary"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? (
              <span>{ICONES_ACESSO.OLHO_ABERTO}</span>
            ) : (
              <span>{ICONES_ACESSO.OLHO_FECHADO}</span>
            )}

            <span className="ms-1">
              +{hiddenItems.length}{" "}
              {hiddenItems.length === 1 ? "item" : "itens"}
            </span>
          </div>

          {/* POPUP */}
          <FloatingPortal>
            {open && (
              <div
                ref={refs.setFloating}
                {...getFloatingProps()}
                style={{
                  ...floatingStyles,
                  zIndex: 9999,
                  background: "#fff",
                  border: "1px solid #dee2e6",
                  borderRadius: 6,
                  padding: 8,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  minWidth: 220,
                }}
              >
                {hiddenItems.map((item) => (
                  <div
                    key={item.value}
                    className="d-flex justify-content-between align-items-center mb-1"
                  >
                    {optionsNoClearable &&
                    optionsNoClearable.includes(
                      fn_isValidNumber(item.value)
                        ? Number(item.value)
                        : item.value,
                    ) ? (
                      <span>{item.label}</span>
                    ) : (
                      <div className="d-flex align-items-center">
                        <span>{item.label}</span>
                        <button
                          type="button"
                          className="ms-2 btn-remove-item"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            const newValue = allSelected.filter(
                              (opt) => opt.value !== item.value,
                            );

                            selectProps.onChange(newValue, {
                              action: "remove-value",
                              removedValue: item,
                            });
                          }}
                        >
                          x
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </FloatingPortal>
        </>
      );
    }

    return null;
  };

  // const OptionCustom = (props) => {
  //   const { data, isSelected, innerRef, innerProps, selectProps } = props;

  //   // Opção de ação
  //   if (data.isAction) {
  //     return (
  //       <div
  //         ref={innerRef}
  //         {...innerProps}
  //         className="d-flex align-items-center px-3 py-2"
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           selectProps.onActionOption?.(data);
  //         }}
  //       >
  //         <input
  //           type="checkbox"
  //           className="form-check-input me-2"
  //           checked={!!data.isChecked}
  //           readOnly
  //         />
  //         <span title={showTooltip ? data.tooltip || "" : ""}>
  //           {data.label}
  //         </span>
  //       </div>
  //     );
  //   }

  //   return (
  //     <components.Option {...props}>
  //       <div className="d-flex align-items-start">
  //         {showCheckbox && (
  //           <input
  //             type="checkbox"
  //             checked={isSelected}
  //             readOnly
  //             className="form-check-input me-2 mt-1"
  //           />
  //         )}

  //         <div className="d-flex flex-column">
  //           <span title={showTooltip ? data.tooltip || "" : ""}>
  //             {data.label}
  //           </span>

  //           {data.texto_explicativo && (
  //             <small className="text-muted">{data.texto_explicativo}</small>
  //           )}
  //         </div>
  //       </div>
  //     </components.Option>
  //   );
  // };

  //Para manter só o label na seleção do select seleção única

  const OptionCustom = (props) => {
    const { data, isSelected, innerRef, innerProps, selectProps } = props;

    // Opção de ação
    if (data.isAction) {
      return (
        <div
          ref={innerRef}
          {...innerProps}
          className="d-flex align-items-center px-3 py-2"
          onClick={(e) => {
            e.stopPropagation();
            selectProps.onActionOption?.(data);
          }}
        >
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={!!data.isChecked}
            readOnly
          />

          <span title={showTooltip ? data.tooltip || "" : ""}>
            {data.label}
          </span>
        </div>
      );
    }

    const mostrarInativo =
      destacarInativo && (data.inativo || data.situacao == "I");

    return (
      <components.Option {...props}>
        <div className="d-flex align-items-start">
          {showCheckbox && (
            <input
              type="checkbox"
              checked={isSelected}
              readOnly
              className="form-check-input me-2 mt-1"
            />
          )}

          <div className="d-flex flex-column">
            <span
              title={showTooltip ? data.tooltip || "" : ""}
              className={mostrarInativo ? "text-secondary" : ""}
            >
              {data.label}
            </span>

            {mostrarInativo && (
              <small className="text-secondary">inativo</small>
            )}

            {data.texto_explicativo && (
              <small className="text-muted">{data.texto_explicativo}</small>
            )}
          </div>
        </div>
      </components.Option>
    );
  };

  const SingleValueCustom = (props) => {
    return (
      <components.SingleValue {...props}>
        {props.data.label}
      </components.SingleValue>
    );
  };

  //Para manter só o label na seleção do select seleção múltipla
  const MultiValueLabelCustom = (props) => {
    return (
      <components.MultiValueLabel {...props}>
        {props.data.label}
      </components.MultiValueLabel>
    );
  };

  function normalizar(texto) {
    return texto
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .replace(/[´`^~]/g, "")
      .replace(/ç/g, "c")
      .toLowerCase();
  }

  const customFilter = (option, inputValue, searchInTexto) => {
    if (!inputValue) return true;

    const valorPesquisa = normalizar(inputValue);

    const label = normalizar(option.label || "");
    const texto = normalizar(option.data?.texto_explicativo || "");

    return searchInTexto
      ? label.includes(valorPesquisa) || texto.includes(valorPesquisa)
      : label.includes(valorPesquisa);
  };

  return (
    <div className={label != null ? "form-group" : ""}>
      {label && (
        <label htmlFor={fieldName} className="label">
          {label}{" "}
          {textHelp && (
            <span>
              <TooltipItem text={textHelp} showImageHelp />
            </span>
          )}
        </label>
      )}

      <Select
        ref={selectRef}
        id={fieldName}
        name={fieldName}
        isSearchable={isSearchable}
        aria-label={ariaLabel ? ariaLabel : label}
        maxMenuHeight={maxMenuHeight != null ? maxMenuHeight : 150}
        placeholder={
          placeholder
            ? placeholder
            : isSearchable
              ? "Digite para pesquisar"
              : "Selecione"
        }
        noOptionsMessage={() => "Sem registros"}
        defaultOptions
        styles={styles || styleSelect}
        classNamePrefix="react-select"
        className={
          error && SHOW_DESC_OBRIGATORIO_FIELDS == false
            ? "react-select-error"
            : ""
        }
        {...rest}
        options={
          showGrupoCheck
            ? fn_agruparOpcoesSelect(rest.options, getGrupoOpcao)
            : rest.options
        }
        formatGroupLabel={(grupo) => (
          <span className="texto-menor text-secondary">{grupo.label}</span>
        )}
        closeMenuOnSelect={showCheckbox ? false : true}
        hideSelectedOptions={showCheckbox || !rest.isMulti ? false : true}
        isOptionDisabled={(option) => optionsDisabled?.includes(option.value)}
        components={{
          ...customComponents,
          Option: OptionCustom,
          SingleValue: SingleValueCustom,
          MultiValueLabel: MultiValueLabelCustom,
        }}
        filterOption={(option, inputValue) =>
          customFilter(option, inputValue, searchInTexto)
        }
      />

      {footer && <div className="ms-1 mt-1 texto-menor">{footer}</div>}

      {error && SHOW_DESC_OBRIGATORIO_FIELDS == true && (
        <small className="text-danger">{error}</small>
      )}
    </div>
  );
}
